var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPolygon = function SvgPolygon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.062.928a1.875 1.875 0 0 1 1.875 0l4.717 2.724c.58.334.937.953.937 1.623v5.447c0 .67-.357 1.289-.937 1.624l-4.717 2.723a1.875 1.875 0 0 1-1.875 0l-4.717-2.723a1.875 1.875 0 0 1-.938-1.624V5.275c0-.67.358-1.289.938-1.623L7.062.928Z",
    stroke: "currentColor",
    strokeWidth: 1.25
  })));
};
export default SvgPolygon;